import gql from 'graphql-tag';

export default gql(`
mutation UpdateSubscriber($id: ID!, $email: String!) {
  updateSubscriber(id: $id, email: $email) {
    id
    email
    createdAt
    status
    notified
  }
}`);


// WEBPACK FOOTER //
// ./src/graphql/MutationEditSubscriber.js